import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import type { PermissionKey } from './types';

export function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return <div className="p-6 text-sm text-muted">Checking session...</div>;
  }
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionKey;
  children: JSX.Element;
}): JSX.Element {
  const auth = useAuth();
  if (auth.hasPermission(permission)) return children;
  return <Navigate to="/dashboard" replace />;
}

export function RequireSuperAdmin({ children }: { children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  if (auth.me?.roleSlug === 'super_admin') return children;
  return <Navigate to="/dashboard" replace />;
}

export function useHasPermission(permission: PermissionKey): boolean {
  return useAuth().hasPermission(permission);
}
